export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.301.0-9146f0d",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
